var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToiletMen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.832 24.5C48.832 37.7548 38.0869 48.5 24.832 48.5C11.5772 48.5 0.832031 37.7548 0.832031 24.5C0.832031 11.2452 11.5772 0.5 24.832 0.5C38.0869 0.5 48.832 11.2452 48.832 24.5Z",
    fill: "#CAD6E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4328 36.5V27.5H20.6328V20.9C20.6328 20.24 20.8678 19.675 21.3378 19.205C21.8078 18.735 22.3728 18.5 23.0328 18.5H26.6328C27.2928 18.5 27.8578 18.735 28.3278 19.205C28.7978 19.675 29.0328 20.24 29.0328 20.9V27.5H27.2328V36.5H22.4328ZM24.8328 17.3C24.1728 17.3 23.6078 17.065 23.1378 16.595C22.6678 16.125 22.4328 15.56 22.4328 14.9C22.4328 14.24 22.6678 13.675 23.1378 13.205C23.6078 12.735 24.1728 12.5 24.8328 12.5C25.4928 12.5 26.0578 12.735 26.5278 13.205C26.9978 13.675 27.2328 14.24 27.2328 14.9C27.2328 15.56 26.9978 16.125 26.5278 16.595C26.0578 17.065 25.4928 17.3 24.8328 17.3Z",
    fill: "#021922"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToiletMen);
export default __webpack_public_path__ + "static/media/Toilet Men.e08838f452c7dfb383e8e1c6f57e2eb3.svg";
export { ForwardRef as ReactComponent };